import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'
import ActivityHistoryCreationPage from 'pages/Profiles/Activity/ActivityHistoryCreate'
// Importez les nouvelles pages que nous allons créer
import ActivityHistoryPreviewPage from 'pages/Profiles/Activity/ActivityHistoryPreview'
import ActivityHistoryEditPage from 'pages/Profiles/Activity/ActivityHistoryEdit'

export const ActivityHistoryRoutes: RouteObject[] = [
  {
    path: '/profile/:profileId/activity/create',
    loader: async ({ params }) => {
      const token = localStorage.getItem('token')
      if (!token) return redirect('/login')
      try {
        const response = await axios.get(
          `${base_url}/profile/${params.profileId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        return response.data
      } catch (error) {
        console.error(error)
        return redirect('/profiles')
      }
    },
    element: <ActivityHistoryCreationPage />,
  },
  // --- NOUVELLES ROUTES ---
  {
    path: '/profile/:profileId/activity/:historyId',
    loader: async ({ params }) => {
      const token = localStorage.getItem('token')
      if (!token) return redirect('/login')
      try {
        // On récupère les deux informations en parallèle pour plus d'efficacité
        const [profileRes, historyRes] = await Promise.all([
          axios.get(`${base_url}/profile/${params.profileId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(
            `${base_url}/profile/${params.profileId}/activity/${params.historyId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          ),
        ])
        // On retourne un objet contenant le profil et l'historique
        return { profile: profileRes.data, history: historyRes.data }
      } catch (error) {
        console.error(error)
        return redirect(`/profile/${params.profileId}`) // Redirige vers la page du profil en cas d'erreur
      }
    },
    element: <ActivityHistoryPreviewPage />,
  },
  {
    path: '/profile/:profileId/activity/:historyId/edit',
    // Le loader est identique à celui de la page de prévisualisation
    loader: async ({ params }) => {
      const token = localStorage.getItem('token')
      if (!token) return redirect('/login')
      try {
        const [profileRes, historyRes] = await Promise.all([
          axios.get(`${base_url}/profile/${params.profileId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(
            `${base_url}/profile/${params.profileId}/activity/${params.historyId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          ),
        ])
        return { profile: profileRes.data, history: historyRes.data }
      } catch (error) {
        console.error(error)
        return redirect(`/profile/${params.profileId}`)
      }
    },
    element: <ActivityHistoryEditPage />,
  },
]
